import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_REFERRAL_COLLECTION_NAME = "referral";

export const useRxCollectionReferral = (): RxCollection<Referral> | null =>
  useRxCollection<Referral>(RXDB_REFERRAL_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<Referral>>;
export type ReferralQueryConstructor = UseRxData["1"];

const REFERRAL_SCHEMA_LITERAL = {
  title: "referral schema",
  version: 4,
  description: "Represents a patient referral",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    patientId: { type: "string" },
    facilityId: {
      type: ["string", "null"],
    },
    freeTextFacility: {
      type: ["string", "null"],
    },
    reasons: {
      type: "array",
      items: {
        type: "string",
      },
    },
    notes: {
      type: ["string", "null"],
    },
  },
  required: ["id", "meta", "patientId", "reasons"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(REFERRAL_SCHEMA_LITERAL);

export type Referral = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const REFERRAL_SCHEMA: RxJsonSchema<Referral> = REFERRAL_SCHEMA_LITERAL;
